import type { IFormState } from "../Interfaces";

export function Add(this: IFormState): FormData {
  const formData = new FormData();

  formData.append("title", this.title.trim());
  formData.append("description", this.description.trim());
  formData.append("application", "askami");
  formData.append("divisionCode", "");

  this.attachments.forEach((attachment) => {
    formData.append("attachments", attachment, attachment.name);
  });

  return formData;
}
